import { PaginatedResult } from "@/types/breeze/Any";
import { SearchResult } from "@/types/breeze/Search";
import { BaseService } from "../BaseService";

export class SearchService extends BaseService {
  public async search(query: string): Promise<PaginatedResult<SearchResult>> {
    return this.getRequest(`/search?q=${encodeURIComponent(query)}`, true);
  }

  public async rehydrate(): Promise<void> {
    return this.postRequest("/search/rehydrate", {}, "", true, true);
  }

  public async rehydrateEntity(entityName: string): Promise<void> {
    return this.postRequest(
      `/search/rehydrate/${entityName}`,
      {},
      "",
      true,
      true,
    );
  }

  public async purge(): Promise<void> {
    return this.deleteRequest("/search/purge", "", true, true);
  }

  public async purgeEntity(entityName: string): Promise<void> {
    return this.deleteRequest(`/search/purge/${entityName}`, "", true, true);
  }
}

export const searchService = new SearchService();
